define([
	'internal_util/Util',
	'internal_util/LocalizationUtil',
	'model/ProviderInfo',
	'amdi18n-loader?!view/nls/ProviderInfoView_strings',
	'lib/jquery'
], function (
	Util,
	LocalizationUtil,
	ProviderInfo,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * ProviderInfoView class
	 */
	return function () {
		var _view = jQuery("<div id='skIdS_providerinfo-container'></div>");


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (providerInfo) {
			var $infoContainer,
				$view;

			if (!(providerInfo instanceof ProviderInfo)) {
				throw new Error('invalid providerInfo');
			}

			$view = jQuery(
					"<div id='skIdS_providerinfo-logo-container'>" +
						"<div>" +
							"<img src='" + providerInfo.image().url() + "' alt='" + Util.toHtml(providerInfo.name()) + "' />" +
						"</div>" +
					"</div>" +
					"<div id='skIdS_providerinfo-info-container'>" +
						"<div>" +
							"<div class='skIdS_providerinfo-info-" + LocalizationUtil.getShortLocale() + "'>"+ Strings.name + "</div>" +
							"<div>" + Util.toHtml(providerInfo.name()) + "</div>" +
						"</div><div>" +
							"<div class='skIdS_providerinfo-info-" + LocalizationUtil.getShortLocale() + "'>" + Strings.url + "</div>" +
							"<div class='skIdS_providerinfo-info_link'>" +
//								"<a href='" + providerInfo.url() + "' target='_blank'>" + providerInfo.url() + "</a>" +
								providerInfo.url() +
							"</div>" +
						"</div>" +
					"</div>");

			$infoContainer = $view.siblings('#skIdS_providerinfo-info-container');

			if (providerInfo.privacyStatement() !== null) {
				if (Util.isValidURL(providerInfo.privacyStatement())) {
					$infoContainer.append(
							"<div>" +
								"<div class='skIdS_providerinfo-info-" + LocalizationUtil.getShortLocale() + "'>" + Strings.privacy_statement + "</div>" +
								"<div class='skIdS_providerinfo-info_link'>" +
//									"<a href='" + providerInfo.privacyStatement() + "' target='_blank'>" + providerInfo.privacyStatement() + "</a>" +
								    providerInfo.privacyStatement() +
								"</div>" +
							"</div>");
				} else {
					$infoContainer.append(
							"<div><div>" + Strings.privacy_statement + "</div><div>" + providerInfo.privacyStatement() + "</div></div>");
				}
			}

			_view.empty();
			_view.append($view);
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ProviderInfoView.js
// module id = 17
// module chunks = 1